import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {fetchBannerText, saveBannerText} from "../aws/DynamoDB";
import {useNavigate} from "react-router-dom";

export default function AdminDashboard() {
    const navigate = useNavigate();

    const [noticeInput, setNoticeInput] = useState("");
    const [admin] = useState(!!localStorage.getItem("username")); // Set to false to disable admin mode
    if (!admin){
        navigate("/");
    }
    const handleNoticeSubmit = (e) => {
        e.preventDefault();
        saveBannerText(noticeInput)
    };

    async function checkBannerText() {
        try {
            const bannerTest = await fetchBannerText();
            if (bannerTest && bannerTest !== "") {
                setNoticeInput(bannerTest);
            }
        } catch (error) {
            console.error('Error fetching banner text:', error);
        }
    }

// Call the function
    useEffect(() => {
        checkBannerText();
    }, []);

    return (
        <Wrapper>
            <Header>
                <h1 className="font40 extraBold">Admin Dashboard</h1>
            </Header>
            <NoticeSection>
                <h2 className="font24 bold">Mitteilungen</h2>
                <NoticeForm onSubmit={handleNoticeSubmit}>
                    <NoticeInput
                        type="text"
                        value={noticeInput}
                        onChange={(e) => setNoticeInput(e.target.value)}
                        placeholder="Geben Sie eine neue Mitteilung ein"
                    />
                    <ButtonInput type="submit" value="Mitteilung setzen" />
                </NoticeForm>
            </NoticeSection>
        </Wrapper>
    );
}

const Wrapper = styled.div`
  padding: 20px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const NoticeSection = styled.div`
  margin-bottom: 30px;
`;

const NoticeForm = styled.form`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
`;

const NoticeInput = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  flex: 1;
`;

const ButtonInput = styled.input`
  padding: 10px 20px;
  background-color: #7620ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #5a0dcc;
  }
`;